<div [hidden]="!show">
	<div class="loader-overlay">
		<div>
			<mat-spinner color="primary"></mat-spinner>
		</div>
	</div>
</div>
